import { useCallback, useEffect, useState } from "react";

import { FormControl, Paper, Typography, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";

import moment from "moment";
import intl from "react-intl-universal";

import { useCardData, useCardSettings } from "../../../Hooks";
import {
  DateFilter,
  ReceiptList,
  ScreenGreeting,
} from "../../../Components/Molecules";
import BackImage from "../../../Assets/no-card.png";
import { Loading, Button } from "../../../Components/Atoms";

import { useStyles } from "./styles";
import { ModalLoader } from "../../../Components/Atoms/ModalLoader";

export const PersonalCard = () => {
  const classes = useStyles();
  const matches = useMediaQuery("(min-width: 1220px)");
  const [typeTransactionSelected, setTypeTransactionSelected] = useState("all");

  const {
    state: cardData,
    handleGET: fetchCardDataGET,
    loading,
  } = useCardData();

  const {
    state: cardSettings,
    handleGET: fetchCardSettingsGET,
    error: cardSettingsError,
    loading: cardSettingsLoading,
  } = useCardSettings();

  useEffect(() => {
    fetchCardSettingsGET();
    fetchCardDataGET({
      start_date: `${moment().startOf("month").format("YYYY-MM-DD")} 00:00:00`,
      end_date: `${moment().format("YYYY-MM-DD")} 23:59:59`,
    });
  }, []);

  const handleFilterSelection = useCallback((value) => {
    const { start_date, end_date } = value;
    const queryParameters = {
      start_date,
      end_date,
    };
    fetchCardDataGET({ ...queryParameters });
  }, []);

  return (
    <>
      <ModalLoader open={loading.GET} text={"Carregando informações"} />
      {Object.keys(cardSettings).length === 0 ? (
        <div className={classes.noCards}>
          <img src={BackImage} width="auto" />
          <Typography variant="h4">
            Você ainda não possui cartões cadastrados!
          </Typography>
          <br />
          <Typography variant="h6">
            Verifique a disponibilidade, através do aplicativo.
          </Typography>
        </div>
      ) : (
        <div className={classes.container}>
          <ScreenGreeting title={intl.get(`phrases.myCard`)} />
          <Grid container spacing={1} alignContent="space-between">
            <Grid item xs={5}>
              <div className={classes.cardContainer}>
                <img src={cardSettings?.asset} />
                <div
                  className={classes.cardDataContainer}
                  style={{
                    color: cardSettings?.type === "black" && "#fff",
                  }}
                >
                  <Typography
                    variant="h5"
                    gutterBottom
                    style={{ letterSpacing: "2px", fontWeight: "bold" }}
                  >
                    •••• •••• ••••{" "}
                    {cardSettings?.mask?.substring(
                      cardSettings?.mask?.length - 4
                    )}
                  </Typography>
                  <img
                    src={cardSettings?.brand_image}
                    width={40}
                    height={20}
                    style={{ marginTop: 5 }}
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={7}>
              <Paper className={classes.paper} elevation={3}>
                <div
                  className={classes.paperHeader}
                  style={{
                    flexDirection: matches ? "row" : "column",
                  }}
                >
                  <DateFilter handleFilter={handleFilterSelection} />
                </div>
                <div className={classes.listContainer}>
                  <ReceiptList
                    hasFilter={true}
                    itens={cardData}
                    loading={loading.GET}
                    type="extract"
                  />
                </div>
              </Paper>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

PersonalCard.propTypes = {};
